import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import PRODUCT_DATA from "../data/products";
import { slugify } from "../utils/helpers";
import SearchBar from "./SearchBar";
import MobileMenu from "./MobileMenu";
import logo from "../assets/sai-logo.png";
import { PHONE_DISPLAY, PHONE_TEL } from "../config/site";

import "./Header.css";

function safeDecodeSlug(slug) {
  try {
    return decodeURIComponent(slug);
  } catch {
    return "";
  }
}

export default function Header() {

  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const categories = Object.keys(PRODUCT_DATA);

  const currentSlug = location.pathname.startsWith("/category/")
    ? safeDecodeSlug(location.pathname.slice("/category/".length))
    : location.pathname === "/"
    ? "home"
    : "";

  return (
    <>
      {/* HEADER */}

      <header className="header">

        <div className="header-inner">

          {/* MOBILE MENU BUTTON */}

          <button
            className="mobile-toggle"
            type="button"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
            aria-expanded={mobileOpen}
          >
            ☰
          </button>

          {/* LOGO */}

          <Link to="/" className="logo">

            <img
              src={logo}
              alt="Sai Concept"
              className="logo-img"
            />

            <div>
              <div className="logo-text">SAI CONCEPT</div>
              <div className="logo-sub">
                YOUR PARTNER IN PROCUREMENT
              </div>
            </div>

          </Link>

          {/* SEARCH */}

          <SearchBar />

          {/* PHONE */}

          <a
            href={`tel:${PHONE_TEL}`}
            className="header-phone"
          >
            {PHONE_DISPLAY}
          </a>

        </div>

      </header>

      {/* NAVIGATION */}

      <nav className="nav">

        <div className="nav-inner">

          <Link
            to="/"
            className={`nav-item nav-home ${
              currentSlug === "home" ? "active" : ""
            }`}
          >
            🏠 Home
          </Link>


          {/* ALL CATEGORY MEGA MENU */}

          <div className="nav-item all-cat" tabIndex={0}>

            ☰ All Categories

            <div className="mega-menu">

              {categories.map((cat) => (

                <Link
                  key={cat}
                  to={`/category/${slugify(cat)}`}
                  className="mega-item"
                >
                  {PRODUCT_DATA[cat].icon} {cat}
                </Link>

              ))}

            </div>

          </div>


          {/* SCROLLABLE CATEGORY LINKS */}

          <div className="category-scroll">

            {categories.map((cat) => (

              <Link
                key={cat}
                to={`/category/${slugify(cat)}`}
                className={`nav-item ${
                  currentSlug === slugify(cat)
                    ? "active"
                    : ""
                }`}
              >
                {PRODUCT_DATA[cat].icon} {cat}
              </Link>

            ))}

          </div>

        </div>

      </nav>


      {/* MOBILE MENU */}

      <MobileMenu
        isOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
        currentSlug={currentSlug}
      />

    </>
  );
}